export default "__VITE_ASSET___QP4ghfY__"